import { z } from 'zod';
import { SystemType, COVERAGE_PROVIDER_TYPES } from '../../systems/SystemType.js';
import { servicesProviderPricingCodeOnlySchema, servicesProviderPricingCodeOnlyDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

/**
 * This is the service that handles payout for coverage to the seller on the deal.
 * We pay out the seller's portion of the coverage markup to this service (i.e. dealership in Omni, Ekho in Access)
 * This is just the markup split - does not include the cost of the product (which is handled by the coverage vendor service)
 *
 * @example Payout breakdown:
 * - Coverage retail cost: $100
 * - Coverage markup: $10 (40% Ekho, 60% Dealer)
 * - Coverage tax: $5
 * - Coverage payout to fulfillment service (coverage_fulfillment): $60
 *
 * For each aggregator-provider relationship, we will have a dealer number (this is the number on the aggregator's side to identify the dealer)
 * @example 1) Dealer number:
 * - Aggregator: PCRS
 * - Provider: McGraw
 * - pcrsMcgrawDealerNumber: '1234567890'
 *
 * @example 2) Dealer number:
 * - Aggregator: PEN
 * - Provider: RidersAdvantage
 * - penRidersAdvantageDealerNumber: '1234567890'
 *
 */
// ============================================================================
// Pricing Schemas
// ============================================================================
const coverageFulfillmentServicePricingSchema = servicesProviderPricingCodeOnlySchema;
const coverageFulfillmentServicePricingDtoSchema = servicesProviderPricingCodeOnlyDtoSchema;
// ============================================================================
// Provider Config Schema
// ============================================================================
const coverageFulfillmentProviderConfigSchema = z.object({
    systemType: z.nativeEnum(SystemType),
    provider: z.enum(COVERAGE_PROVIDER_TYPES),
    dealerNumber: z.string(),
    clientConfigId: z.string(),
});
// ============================================================================
// Core Schema
// ============================================================================
const coverageFulfillmentServiceConfigSchema = serviceConfigSchema.extend({
    /** Dealer's config per aggregator-provider */
    providerConfigs: z.array(coverageFulfillmentProviderConfigSchema).optional(),
    pricing: z.array(coverageFulfillmentServicePricingSchema),
    // fulfillment pricing is 1-(platform pricing)
});
// ============================================================================
// DTO Schema
// ============================================================================
const coverageFulfillmentProviderConfigDtoSchema = coverageFulfillmentProviderConfigSchema;
const coverageFulfillmentServiceConfigDtoSchema = serviceConfigSchema.extend({
    providerConfigs: z.array(coverageFulfillmentProviderConfigDtoSchema).optional(),
    pricing: z.array(coverageFulfillmentServicePricingDtoSchema),
});

export { coverageFulfillmentProviderConfigDtoSchema, coverageFulfillmentProviderConfigSchema, coverageFulfillmentServiceConfigDtoSchema, coverageFulfillmentServiceConfigSchema, coverageFulfillmentServicePricingDtoSchema, coverageFulfillmentServicePricingSchema };
//# sourceMappingURL=CoverageFulfillmentServiceConfig.js.map
